import { TimeZonePropTypes } from "./propTypes";
import clsx from "clsx";
import { addCustomPadding } from "../../utils/CustomPadding/index";
import "./styles.scss";

/* #META
 {
  "NAME": "TimeZone",
  "CLASSNAME": "time-zone-component",
  "URL": "http://nicasource.local"
 }
#ENDMETA */

function parseCountries(input) {
  if (!input) return [];
  const parts = (/\r|\n/.test(input) ? input.split(/[\r\n]+/) : input.split(/\s*,\s*/))
    .map((s) => s.trim())
    .filter(Boolean);
  return Array.from(new Set(parts)).slice(0, 2);
}

const TimeZones = ({ timeZoneGallery, variant }) =>
  timeZoneGallery?.map(
    (
      {
        time_clock_format: timeClockFormat,
        time_gallery_img: timeGalleryImg,
        time_zone_countries: timeZoneCountries,
        time_zone_title: timeZoneTitle,
      },
      index
    ) => (
      <div key={index} className="time-zone-content-gallery-card">
        {timeGalleryImg && (
          <div className="gallery-card-image-container">
            <img src={timeGalleryImg.url} alt={timeGalleryImg.alt} className="gallery-card-image" />
            <div className="gallery-card-mask-blurry" />
          </div>
        )}

        <div
          className={clsx(
            "gallery-card-title-container",
            variant === "few" && "gallery-card-title-container--few",
            variant === "three" && "gallery-card-title-container--three",
            variant === "many" && "gallery-card-title-container--many"
          )}
        >
          {timeZoneTitle && <h3 className="gallery-card-title">{timeZoneTitle}</h3>}
        </div>

        <div className="gallery-card-information-container">
          <div className="flex flex-col pb-6">
            {parseCountries(timeZoneCountries).map((country, i) => (
              <p key={`country-${i}`} className="gallery-card-country mt-0">
                {country}
              </p>
            ))}
          </div>
          {timeClockFormat && <p className="gallery-card-clock-format">{timeClockFormat}</p>}
        </div>
      </div>
    )
  );

const TimeZone = ({ data }) => {
  const {
    time_zone_gallery: timeZoneGallery,
    custom_padding: customPadding,
    custom_top: customTopPadding,
    custom_bottom: customBottomPadding,
  } = data;

  const zonesCount = Array.isArray(timeZoneGallery) ? timeZoneGallery.length : 0;
  const variant =
    zonesCount === 0 ? "none" : zonesCount <= 2 ? "few" : zonesCount === 3 ? "three" : "many";

  const pad = addCustomPadding({
    customEnabled: !!customPadding,
    topPx: customTopPadding,
    bottomPx: customBottomPadding,
  });

  return (
    <section className={clsx("time-zone-component", pad.className)} style={pad.style}>
      <div className="time-zone-content container-revamp xl:px-0">
        <div className="time-zone-content-gallery">
          <TimeZones timeZoneGallery={timeZoneGallery} variant={variant} />
        </div>
      </div>
    </section>
  );
};

TimeZone.propTypes = TimeZonePropTypes;

export default TimeZone;
